import { z } from 'zod'

export type BulkUpdateImporterFormData = {
  importerId: string
}

const schema = z
  .object({ importerId: z.string() })
  .refine(data => data.importerId !== '', {
    message: 'At least one field must be selected for update'
  })

export const getInitialFormData = (): BulkUpdateImporterFormData => ({
  importerId: ''
})

export const validateBulkUpdateImporterForm = (data: BulkUpdateImporterFormData) =>
  schema.safeParse(data)

export const EMPTY_VALUE = '__EMPTY__'
